module.exports = __webpack_public_path__ + "img/footer-discord.616f82d5.png";